import { searchAPIClient as axios } from 'src/api/config';
import { merge, reduce } from 'lodash';
import { env } from 'src/config/env';

export const createParams = (params = {}, page = {}) => {
  // Determine if querying for service areas
  const serviceAreaState = params['programs.service_areas']?.region?.state ?? null;
  const serviceAreaNational = serviceAreaState ? true : null;
  const referable = params.referable ?? {};

  if (serviceAreaState) {
    // eslint-disable-next-line no-param-reassign
    delete params['programs.service_areas'];
  }

  const filters = {
    licensed: params.licensed,
    query: params.query,
    networks: params.networks,
    // only query for active providers unless explicitly stated otherwise
    active: !(params.state && params.state === 'false'),
    type: params.type,
  };

  if (typeof params.sensitive === 'boolean') {
    filters.sensitive = params.sensitive;
  }

  const locations = {
    latitude: params.locations?.radius.latitude || null,
    longitude: params.locations?.radius.longitude || null,
    distance: params.locations?.radius.distance || null,
  };

  const pageParsed = {
    number: page.page.number || null,
    size: page.page.size || null,
  };

  // matches for 'programs.' and at least one more char to pull filters relating to programs
  const programsParams = Object.keys(params)
    .filter((paramKey) => paramKey.match(/programs\..+/))
    .reduce((obj, key) => {
      const value = params[key];
      if (!value) {
        return obj;
      }
      const splitKey = key.split('programs.')[1];
      // eslint-disable-next-line no-param-reassign
      obj[splitKey] = params[key];
      return obj;
    }, {});

  const programs = {
    ...programsParams,
  };

  const include = 'locations';

  const sort = page.sort === 'name' ? 'provider-name-a-to-z' : page.sort;

  return merge(
    reduce(filters, (acc, f, key) => ({ ...acc, ...{ [`filter[${key}]`]: f } }), {}),
    reduce(programs, (acc, f, key) => ({ ...acc, ...{ [`filter[programs.${key}]`]: f } }), {}),
    reduce(locations, (acc, f, key) => ({ ...acc, ...{ [`filter[locations][radius][${key}]`]: f } }), {}),
    reduce(pageParsed, (acc, f, key) => ({ ...acc, ...{ [`page[${key}]`]: f } }), {}),
    reduce(referable, (acc, f, key) => ({ ...acc, ...{ [`filter[referable][${key}]`]: f } }), {}),
    serviceAreaState && { 'filter[programs.service_areas][region][state]': serviceAreaState },
    serviceAreaNational && { 'filter[programs.service_areas][region][national]': serviceAreaNational },
    { 'filter[include_pathways]': params.include_pathways ?? false },
    { 'filter[include_payments]': params.include_payments ?? false },
    { include },
    !serviceAreaState && { sort },
  );
};

export const responseTransformer = (data) => data.map((provider) => {
  const document = provider.document;

  const dataMap = {
    id: provider.id,
    licensed: document.licensed,
    name: document.name,
  };

  return dataMap;
});

const fetchProviderBrowseResultsFromSearch = async (params, page) => {
  const providersUrl = `${env.SEARCH_API}/providers`;

  const parsedParams = createParams(params, page);

  const response = await axios.get(providersUrl, {
    params: parsedParams,
    transformResponse: (res) => res, // prevent Axios running JSON.parse() on data
  });

  const resData = JSON.parse(response.data);

  const currPage = page.page.number || 1;

  const paging = {
    current_page: currPage,
    next_page: resData.meta.page.total_pages > currPage ? currPage + 1 : null,
    per: page.page.size,
    prev_page: currPage > 1 ? currPage - 1 : null,
    total_count: resData.meta.page.total_count,
    total_pages: resData.meta.page.total_pages,
  };

  const transformedData = responseTransformer(resData.data);
  return {
    ...response,
    data: {
      paging,
      data: transformedData,
      meta: resData.meta,
    },
  };
};

export default fetchProviderBrowseResultsFromSearch;
